import { Button, Form, Input, message } from 'antd';
import axios from 'axios';
import React from 'react';

function Login({ setAuth }) {



    return (
        <>
            <Form
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={(v) => {
                    axios.post('/fuser/login', v).then(res => {
                        if (res.data.token) {
                            setAuth(false);
                            localStorage.setItem('token', res.data.token);
                        } else {
                            message.error('Login yoki parol hato');
                        }
                    }).catch(err => {
                        message.error('Login yoki parol hato');
                    });
                }}
                onFinishFailed={(v) => {
                    setAuth(false);
                }}
            >
                <Form.Item
                    label="Login"
                    name="login"
                    rules={[
                        {
                            required: true,
                            message: 'Iltimos loginni kiriting!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Parol"
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Iltimos parolni kiriting!',
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item label={null}>
                    <Button block type="primary" htmlType="submit">
                        Kirish
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Login;